export default {
  adventure: 'Aventure',
  normal: 'Normal',
  chase: 'Course poursuite',
  custom: 'Personnalisé (action game)',
  horde: 'Horde',
  photo_hunt: 'Chasse à la photo',
  qrcode_visit: 'QRCode',
  fitness: 'Parcours Sportif'
}
